<template>
  <div
    class="selectpricewrap"
    :class="{ collapsible_itme_bottom }"
    @click.prevent
  >
    <div
      v-if="disable_select"
      :class="regular_price_wrap ? 'regular_price_wrap' : ''"
    >      
    <!-- 原始价格 -->
      <span v-if="show_regular_price_before&&regular_price_num" class="product_price_cross secondary_title" :style="{ fontSize: regularFontSize + 'px' }">
        <span v-if="showCountryBefore && country" class="regular_price_text " style="margin:0;">
          {{ country }}
        </span>
        <span class="money regular_price_text" >
          <span style="margin-right:-4px;">
            {{country ? getSymbolFromCurrency(country) : getSymbolFromCurrency(pricetype)}}
          </span>
          <v-pricesup
            v-if="currency_style == 'centsub'"
            :price="computePrice(regular_price_num, disable_select, country)"
          ></v-pricesup>
          <template v-else>
            {{computePrice(regular_price_num, disable_select, pricetype)}}
          </template>
        </span>
      </span>
      <!-- 禁止货币选择时候，如果传入国家还是会根据传入的国家显示货币符号和汇率，可满足showtime主题在开启货币选择时仅在头部显示货币列表，商品列表处价格样式任然显示被禁用的样式，
      此时只需要在外部传入$store里国家，并且disable_select为真即可满足需求，若仅disable_select为真，不传入国家则会使用结账国家符号，汇率-->
      <span class="product_price_price">
        <span
          class="money secondary_title"
          :class="{
            saveprice: saletag,
            price_text: !saletag && default_price_class !== false,
          }"
          :style="{ fontSize: fontSize + 'px' }"
        >
          <span v-if="showCountryBefore && country">
            {{ country  }}
          </span>
          <span v-if="country && !showCountryBefore && $store.state.theme_name === 'default' ">
            {{ country }}
          </span>
          <span style="margin-right:-4px;">
            {{
              country
                ? getSymbolFromCurrency(country)
                : getSymbolFromCurrency(pricetype)
            }}
          </span>
          <v-pricesup
            v-if="currency_style == 'centsub'"
            :price="computePrice(price, disable_select, country)"
          ></v-pricesup>
          <template v-else>
            {{ computePrice(price, disable_select, pricetype) }}
          </template>
          <span v-if="country && !showCountryBefore && show_country !== false && (this.theme != 'vogue' ?  true : !no_show_country.includes(country))  && $store.state.theme_name !== 'default' ">
            {{ country }}
          </span>
        </span>
      </span>
      <!-- 原始价格 -->
      <span v-if="!show_regular_price_before&&regular_price_num" class="product_price_cross" :style="{ fontSize: regularFontSize + 'px' }">
        <span v-if="showCountryBefore && country" class="regular_price_text">
          {{ country }}
        </span>
        <span  class="money regular_price_text secondary_title" >
          {{
            country
              ? getSymbolFromCurrency(country)
              : getSymbolFromCurrency(pricetype)
          }}
          <v-pricesup
            v-if="currency_style == 'centsub'"
            :price="computePrice(regular_price_num, disable_select, country)"
          ></v-pricesup>
          <template v-else>
            {{ computePrice(regular_price_num, disable_select, pricetype) }}
          </template>
        </span>
      </span>
    </div>
    <div v-else-if="noprice">
      <div
        class="secondary_title menu_icon_color"
        ref="selectpricewrap"
        :style="noprice_style"
        :class="theme=='vogue'?'vogue_secondary_title':''"
      >
        <span
          v-if="(model == 'vogue' || model == 'default')&&$store.state.theme_name !== 'athena'"
          :class="`iconfont-cy-rd icon-cy-rd-${pricetype&&pricetype.trim()}`"
        ></span>
        <span v-else  :class="`iconfont-cy icon-cy-${pricetype&&pricetype.trim()}`" style="font-size: 20px;"></span>
        <span v-if="show_country !== false">{{ pricetype }}</span>
        <span class="iconfont icon-cm-xia" v-if="model != 'vogue'"></span>
        <v-pricelist
          ref="pricelist"
          :appendToBody="appendToBody"
          :model="model"
          :nav_bottom="nav_bottom"
          :type="type"
          :collapsible_itme_bottom="collapsible_itme_bottom"
          :back_color="back_color"
          :keepRight="keepRight"
        ></v-pricelist>
      </div>
    </div>
    <div v-else>
      <i
        class="price regular_price_text secondary_title"
        :style="{ fontSize: regularFontSize + 'px' }"
        v-if="regular_price_num"
      >
        <!-- <span class="secondary_title" v-if="pricetype == 'CNY'">CN</span> -->
        {{
           $store.state.theme_name === 'default' ?  `${$store.state.pricetype} ${getSymbolFromCurrency(pricetype)}${computePrice(
            regular_price_num
          )}` :
          `${getSymbolFromCurrency(pricetype)}  ${computePrice(
            regular_price_num
          )}`
        }}
      </i>
      <div class="selectpricewrap" ref="selectpricewrap">
        <div class="selectprice">
          <i
            class="price secondary_title"
            :class="regular_price ? 'regular_price_text' : 'price_text'"
            :style="{ fontSize: fontSize + 'px' }"
          >
            <!-- <span class="secondary_title" v-if="pricetype == 'CNY'">CN</span> -->
            {{
              $store.state.theme_name === 'default' ? `${pricetype} ${getSymbolFromCurrency(pricetype)}${computePrice(
                price
              )}`
              : 
              `${getSymbolFromCurrency(pricetype)} ${computePrice(
                price
              )}`
            }}
          </i>
          <b
            class="iconfont icon-cm-shangxia"
            :style="{ fontSize: fontSize - 2 + 'px' }"
          />
        </div>
        <v-pricelist
          :back="back_color"
          :appendToBody="appendToBody"
          :type="type"
          :keepRight="keepRight"
        ></v-pricelist>
      </div>
    </div>
  </div>
</template>
<script>
import vPricesup from "./pricesup";
import getSymbolFromCurrency from "currency-symbol-map";
import vPricelist from "./pricelist";
import { mapState } from "vuex";
export default {
  props: [
    "price",
    "regular_price_num",
    "regular_price",
    "fontSize",
    "type",
    "regularFontSize",
    "disable_select",
    "country",
    "appendToBody",
    "noprice",
    "noprice_style",
    "saletag",
    "currency_style",
    "regular_price_wrap",
    "model",
    "default_price_class",
    "show_country",
    "nav_bottom", // 定位在当前模块下方  需给父级页头导航添加id  header-nav-bottom
    "collapsible_itme_bottom", // 定位在折叠菜单项下方，并且可撑开折叠菜单项， 需给当前折叠菜单项添加id collapsible-meun-item-bottom
    "back_color",
    "keepRight",
    "showCountryBefore",
    "show_regular_price_before",
  ],
  data() {
    return {
      totalprice: "",
      symbol: {
        AUTO: "$",
        AUD: "$",
        CAD: "$",
        CNY: "CN ￥",
        EUR: "€",
        GBP: "£",
        JPY: "￥",
        NZD: "$",
        USD: "$",
      },
      show: false,
      getSymbolFromCurrency: "",
      theme: "",
      no_show_country:['EUR','GBP','USD']
    };
  },
  computed: {
    ...mapState({
      pricetype: (state) => state?.pricetype,
    }),
  },
  methods: {
    showpricelist() {
      this.$(".vogue-icon").css("display", "block")
      if (this.appendToBody !== false) {
        let el = this.$(this.$el.childNodes[0].lastChild);
        let offset = el.offset();
        let height = el.outerHeight();
        this.$("body>.pricelistbox").css({
          top: offset.top + height + "px",
          left: offset.left+190 >  document.body.offsetWidth ? offset.left + el.outerWidth() - 190 + "px" : offset.left + "px",
        });
        this.$("body>.pricelistbox>.pricelist").animate(
          { height: "toggle", opacity: "toggle" },
          300
        );
      } else {
        if(this.theme=='venue'||this.theme=='default'){
          let el = this.$(this.$el.childNodes[0].lastChild);
          let offset = el.offset();
          this.$(this.$el.childNodes[0].lastChild.lastChild.lastChild).css({
            position: "relative",
            left: document.body.offsetWidth - offset.left > 190 ? "0px" : el.outerWidth() - 190 + "px",
          })
        }
        this.$(this.$el.childNodes[0].lastChild.lastChild.lastChild).animate(
          { height: "toggle", opacity: "toggle" },
          300
        );
      }
      if (this.nav_bottom) {
        this.$(".section-header").removeClass("transparent_head");
        this.$(this.$el.childNodes[0].lastChild.lastChild.lastChild).css(
          "display",
          "flex"
        );
      }
      this.show = true;
    },
  },
  beforeMount() {
    this.getSymbolFromCurrency = getSymbolFromCurrency;
  },
  mounted() {
    this.theme = window.current_theme;
    let $el_length = this.$('.selectpricewrap').length;
    this.$(".vogue-icon").css("display", "none")
    if (!this.disable_select) {
      document.body.addEventListener(
        "click",
        (e) => {
          if (this.isParent(e.target, this.$el)) {
            //判断是否是本身的组件显示状态
            // 页面只有一个该元素时直接切换就好
            if (!this.show || $el_length == 1) {
              setTimeout(this.showpricelist, 1);
            } else {
              this.$(".pricelist").css("display", "none");
              this.$(".vogue-icon").css("display", "none")
              this.show = false;
            }
          } else {
            this.$(".pricelist").css("display", "none");
            this.$(".vogue-icon").css("display", "none")
            this.show = false;
          }
        },
        false
      );
    }
  },
  components: {
    vPricelist,
    vPricesup,
  },
};
</script>
<style scoped lang='scss'>
.price_text {
  color: var(--price-color);
}
.regular_price_text {
  text-decoration: line-through !important;
  margin-right: 10px;
  cursor: auto;
  font-style: normal;
  color: var(--regular-color);
}
.product_price_price {
  font-family: "oswald", sans-serif;
  line-height: 1;
  font-size: 20px;
  margin-top: 6px;
  cursor: auto;
}
.product_price_cross {
  font-family: "oswald", sans-serif;
  position: relative;
  margin-left: 6px;
  color: #b89797;
  font-size: 17px;
  cursor: auto;
  white-space: nowrap;
}
.selectpricewrap {
  display: inline-block;
  line-height: 1.5;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(23, 178, 235, 0.3) !important;
  .regular_price_wrap {
    display: flex;
    flex-direction: column-reverse;
    span {
      margin: 0;
    }
  }
  ul {
    padding: 0;
    li {
      list-style: none;
    }
  }
  .selectprice {
    display: inline-block;
    border: 1px solid rgb(240, 240, 240);
    padding: 2px;
    color: black;
    white-space: nowrap;
    font-size: 14px;
    .price {
      color: #b00404;
      font-weight: 400;
      font-style: normal;
    }

    & > b {
      vertical-align: baseline;
    }
    &:hover {
      opacity: 0.8;
    }
  }
}
.collapsible_itme_bottom {
  height: auto !important;
  .pricelistbox {
    position: unset !important;
    .pricelist {
      position: unset !important;
    }
  }
}

.vogue_secondary_title{
  display: flex;
  align-items: center;
  .iconfont-cy-rd {
    font-size: 19px !important;
    margin-right: 5px !important;
  }
}


@media screen and (max-width: 768px) {
  .selectpricewrap {
    .currencyCountry {
      display: none;
    }
  }
  .product_price_cross {
    display: inline-block;
  }
}
</style>
